export const bronzeFormStyle = {
  container: "md:flex flex-wrap flex-col",
  containerTitle: "text-xl text-slate-300 mt-3 mb-3",

  containerLine: "md:flex pt-6 pb-6 flex-nowrap",
  containerLineTitle: "flex h-full w-full md:w-40 w-40 min-w-40 mr-5 mt-4",
  containerLineTitleText: "w-full mb-2 md:mb-0",

  containerLineContent: "grow",
  containerLineContentLoader: "w-full flex justify-center p-4 bg-slate-50 rounded-sm",

  tooltipContainer: "mr-auto",
  tooltipContainerIcon: "text-white dark:text-slate-900 bg-primary rounded-full h-5 w-5 ml-2"
};
